<template>
    <div class="modal-card" style="width: auto">
        <header class="modal-card-head">
            <p class="modal-card-title">
                <b-icon icon="road" class="m-2"></b-icon>
                Ajout des frais de mission
            </p>
        </header>
        <section class="modal-card-body">

            <b-field label="Type de frais">
                <b-select v-model="payload.fm" placeholder="Ajouter">
                    <option
                            v-for="option in refFrais"
                            :value="option.lib"
                            :key="option.lib">
                        {{ option.lib }}
                    </option>
                </b-select>
            </b-field>

            <b-field label="Nombre"
                     v-if="unitFrais() && payload.fm ">
                <b-input type="number" min="0" step="1" v-model="payload.nbunits">
                </b-input>
            </b-field>

            <b-field label="Somme"
                     v-if="!unitFrais() && payload.fm">
                <b-input type="number" min="0" step="0.01" v-model="payload.cost">
                </b-input>
            </b-field>

            <b-field label="Coût"
                    v-if="updateCost">
                {{ updateCost }} €
            </b-field>

            <b-field label="N° devis">
                <b-input type="text" v-model="payload.devis">
                </b-input>
            </b-field>

          <b-field label="Commentaire">
            <b-input type="text" v-model="payload.comment">
            </b-input>
          </b-field>

        </section>
        <footer class="modal-card-foot">
            <button class="button" type="button" @click="$parent.close()">
                Annuler
            </button>
            <button class="button is-primary" @click="addFM">Enregistrer</button>
        </footer>
    </div>
</template>

<script>
    export default {
        name: "FMAddModal",
        props: {
            refFrais: {
                type: Array,
                required: true
            }
        },
        computed: {
            updateCost() {
                if (this.payload.fm && this.payload.nbunits) {
                    const f = this.refFrais.find(element => element.lib === this.payload.fm);
                    return f.unit ? f.unitCost * this.payload.nbunits : null;
                } else if (this.payload.fm && !this.payload.nbunits) {
                    return
                } else {
                    return null;
                }
            }
        },
        data() {
            return {
                payload: {},
            };
        },
        methods: {
            unitFrais() {
                if (this.payload.fm) {
                    const t = this.refFrais.find(element => element.lib === this.payload.fm);
                    return t.unit
                } else {
                    return false
                }
            },
            addFM() {
                if (parseInt(this.payload.nbunits) >= 1 && this.payload.fm !== undefined) {
                    this.payload.nbunits = Math.round(this.payload.nbunits)
                    this.payload.cost = this.updateCost;
                    this.$emit("add-fm", this.payload);
                } else if (this.payload.cost) {
                    this.payload.cost = parseFloat(this.payload.cost)
                    this.payload.nbunits = null
                    this.$emit("add-fm", this.payload);
                } else {
                    this.$buefy.snackbar.open(
                        {
                            message: `Mauvaise saisie, merci de vérifier`,
                            type: 'is-danger',
                            position: 'is-bottom-left'
                        });
                }
            }
        }
    };
</script>

<style scoped></style>
